/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RoleGroupsGroupsInner } from './RoleGroupsGroupsInner';
import {
    RoleGroupsGroupsInnerFromJSON,
    RoleGroupsGroupsInnerFromJSONTyped,
    RoleGroupsGroupsInnerToJSON,
} from './RoleGroupsGroupsInner';

/**
 * 
 * @export
 * @interface RoleGroups
 */
export interface RoleGroups {
    /**
     * 
     * @type {Array<RoleGroupsGroupsInner>}
     * @memberof RoleGroups
     */
    groups?: Array<RoleGroupsGroupsInner>;
}

/**
 * Check if a given object implements the RoleGroups interface.
 */
export function instanceOfRoleGroups(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RoleGroupsFromJSON(json: any): RoleGroups {
    return RoleGroupsFromJSONTyped(json, false);
}

export function RoleGroupsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleGroups {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groups': !exists(json, 'groups') ? undefined : ((json['groups'] as Array<any>).map(RoleGroupsGroupsInnerFromJSON)),
    };
}

export function RoleGroupsToJSON(value?: RoleGroups | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groups': value.groups === undefined ? undefined : ((value.groups as Array<any>).map(RoleGroupsGroupsInnerToJSON)),
    };
}

